module.exports = __webpack_public_path__ + "static/media/cams_login_bg.3d121bcc.png";


//////////////////
// WEBPACK FOOTER
// ./src/AntD/assets/img/cams_login_bg.png
// module id = 815
// module chunks = 0